"use client";

import { useTranslation } from "@/lib/i18n";
import Link from "next/link";
import React from "react";
import { Trans } from "react-i18next";

const ContactUsContent: React.FC<{ lng: string }> = (props) => {
  const { t } = useTranslation({ ns: "contact", lng: props.lng });

  return (
    <div className="container mt-4 grid gap-10 px-4 text-gray-900  md:gap-16 md:px-6">
      <div className="grid items-start ">
        <div className="space-y-4">
          <p className="text-gray-500">
            <Trans key="weWouldBe" i18nKey="weWouldBe" t={t}>
              <span className="underline"></span>
            </Trans>
          </p>
          <p className="text-gray-500">
            <Trans key="youCanContact" i18nKey="youCanContact" t={t}>
              <Link
                href="mailto:support@talencat.com"
                target="_blank"
                className="underline"
              ></Link>
            </Trans>
          </p>
          <p className="text-gray-500">{t("thisEmail")}</p>
        </div>
      </div>
      <div className="grid items-start ">
        <div className="space-y-4">
          <h2 className="text-center text-2xl font-bold">
            {t("paternersAndBusinesses")}
          </h2>
          <p className="text-gray-500">
            <Trans key="ifYouWant" i18nKey="ifYouWant" t={t}>
              <Link
                href="mailto:partners@talencat.com"
                target="_blank"
                className="underline"
              ></Link>
            </Trans>
          </p>
        </div>
      </div>
      <div className="grid items-start ">
        <div className="space-y-4">
          <h2 className="text-center text-2xl font-bold">{t("commonFAQs")}</h2>
          <p className="text-gray-500">{t("ifYouHave")} </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUsContent;
